import React, { Component } from "react";
import ImageSliders from "../Components/ImageSliders";

export default class CakeDetails extends Component {
  render() {
    return (
      <div className="container-fliud">
        <div className="row col-12">
          <div className="col-4">
            <div className="Cake_sidebar card">
              <div className="card-bsody">
                <div className="media-list media-list-hover media-list-divided">
                  <div className="media b-1">
                    <a className="align-self-center" href="#_">
                      <img
                        className="avatar"
                        src="http://thetheme.io/theadmin/assets/img/avatar/1.jpg"
                        alt="..."
                      />
                    </a>
                    <div className="media-body">
                      <p>
                        <a className="hover-primary" href="#_">
                          <strong>Maryam Amiri</strong>
                        </a>
                        <time
                          className="float-right"
                          dateTime="2018-07-14 20:00"
                        >
                          24 min ago
                        </time>
                      </p>
                      <p>Updated his profile picture.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-8">
            <div className="card image_container">
              <header className="card-header">
                <h4 className="card-title">Images List</h4>
              </header>

              <div className="card-body">
                <div className="container">
                  <div className="row gap-y gap-2">
                    <div className="col-6 col-lg-4">
                      <ImageSliders
                        images={[
                          "https://dev-ncapi.narayaniconcept.com/assets/DMN/Products/NBC136NBC/NBC136NBC.jpg",
                        ]}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card cake_details">
              <header className="card-header">
                <h4 className="card-title text-info">
                  BlackForest
                  <small className="sidetitle text-danger">
                    #BOK123213123123132
                  </small>
                </h4>
                <h5 className="text-danger">2 Pound</h5>
              </header>
              <div className="card-body">
                <div className="row">
                  <div className="col-12">
                    <div className="row">
                      <div className="col-9">
                        <div className="row">
                          <div className="col">
                            <h5>Order Information</h5>
                            <ul className="nav flex-column">
                              <li className="nav-item">
                                <span className="nav-link">
                                  <span className="material-icons-outlined">
                                    schedule
                                  </span>
                                  <span className="title">12:00 AM</span>
                                </span>
                              </li>
                              <li className="nav-item">
                                <span className="nav-link">
                                  <span className="material-icons-outlined">
                                    delivery_dining
                                  </span>
                                  <span className="title">Delivery</span>
                                </span>
                              </li>
                              <li className="nav-item">
                                <span className="nav-link">
                                  <span className="material-icons-outlined">
                                    account_circle
                                  </span>
                                  <span className="title">User Name</span>
                                </span>
                              </li>
                              <li className="nav-item">
                                <span className="nav-link">
                                  <span className="material-icons-outlined">
                                    emoji_people
                                  </span>
                                  <span className="title">Order Attend</span>
                                </span>
                              </li>
                            </ul>
                          </div>
                          <div className="col">
                            <h5>Delivery Information</h5>
                            <ul className="nav flex-column">
                              <li className="nav-item">
                                <span className="nav-link">
                                  <span className="material-icons-outlined">
                                    hail
                                  </span>
                                  <span className="title">Pick User Name</span>
                                </span>
                              </li>
                              <li className="nav-item">
                                <span className="nav-link">
                                  <span className="material-icons-outlined">
                                    phone
                                  </span>
                                  <span className="title">1234567890</span>
                                </span>
                              </li>
                              <li className="nav-item">
                                <span className="nav-link">
                                  <span className="material-icons-outlined">
                                    sticky_note_2
                                  </span>
                                  <span className="title">
                                    Happy Birthday my love is here
                                  </span>
                                </span>
                              </li>
                              <li className="nav-item">
                                <span className="nav-link">
                                  <span className="material-icons-outlined">
                                    map
                                  </span>
                                  <span className="title">
                                    Bidur-9,Nuwakot near asd bank and asd
                                    location
                                  </span>
                                </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="col-3 ">
                        <div className="row">
                          <button className="col btn btn-w-md btn-multiline btn-warning">
                            <span className="material-icons-outlined">
                              report_problem
                            </span>
                            <br />
                            Report
                          </button>
                          <br />
                          <button className="col btn btn-w-md btn-multiline btn-success">
                            <span className="material-icons-outlined">
                              task_alt
                            </span>
                            <br />
                            Mark Done
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
